export interface RequestOptions {
  readonly params?: Record<string, string | number | undefined>;
  readonly headers?: HeadersInit;
  readonly method?: string;
  readonly body?: unknown;
}

export interface LeaderboardParams {
  readonly campaign: string;
}

export interface LeaderboardResponse {
  readonly data: {
    readonly page: {
      readonly leaderboard: {
        readonly nodes: {
          readonly slug: string;
          readonly legacyId: number;
          readonly title: string;
          readonly status: string;
          readonly donationSummary?: {
            readonly totalAmount?: {
              readonly value: number;
              readonly currencyCode: string;
            };
          };
        }[];
        readonly totalCount: number;
        readonly pageInfo: {
          readonly endCursor?: string;
          readonly hasNextPage: boolean;
        };
      };
    };
  };
}

export interface LeaderboardItem {
  readonly slug: string;
  readonly legacyId: number;
  readonly title: string;
  readonly donationAmount?: number | string;
  readonly currencyCode?: string;
  readonly currencySymbol?: string;
  readonly status?: string;
}
